"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DND_TYPE = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactDnd = require("react-dnd");

var _styles = require("./styles");

var _Card = _interopRequireDefault(require("../Card"));

var DND_TYPE = 'IMAGE';
exports.DND_TYPE = DND_TYPE;

var getDnDState = function getDnDState(_ref, monitor, component) {
  var sourceIndex = _ref.sourceIndex,
      targetIndex = _ref.targetIndex;
  // Determine rectangle on screen
  var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect(); // Get vertical middle

  var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2; // Determine mouse position

  var clientOffset = monitor.getClientOffset(); // Get pixels to the top

  var hoverClientY = clientOffset.y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
  // When dragging downwards, only move when the cursor is below 50%
  // When dragging upwards, only move when the cursor is above 50%
  // Dragging downwards

  if (sourceIndex < targetIndex && hoverClientY < hoverMiddleY) return; // Dragging upwards

  if (sourceIndex < targetIndex && hoverClientY < hoverMiddleY) return;
  return true;
};

var imageSource = {
  beginDrag: function beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    };
  }
};
var imageTarget = {
  hover: function hover(props, monitor, component) {
    var source = monitor.getItem();
    var dnd = {
      originalSourceIndex: source.index,
      sourceIndex: source.hoverIndex || source.index,
      targetIndex: props.index
    };
    if (dnd.sourceIndex === dnd.targetIndex || dnd.originalSourceIndex === dnd.targetIndex) return;else if (getDnDState(dnd, monitor, component)) {
      // Time to actually perform the action
      if (props.onHover) props.onHover(dnd); // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.

      source.hoverIndex = dnd.targetIndex;
    } else {
      source.hoverIndex = undefined;
    }
  },
  drop: function drop(props, monitor) {
    var dnd = {
      sourceIndex: monitor.getItem().index,
      targetIndex: monitor.getItem().hoverIndex
    }; // Time to actually perform the action

    if (props.onDrop) props.onDrop(dnd);
  }
};
var Target = (0, _reactDnd.DropTarget)(DND_TYPE, imageTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
});
var Source = (0, _reactDnd.DragSource)(DND_TYPE, imageSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
});

var DraggableImage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(DraggableImage, _Component);

  function DraggableImage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, DraggableImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DraggableImage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onActivate", function () {
      var onActivate = _this.props.onActivate;
      if (onActivate) onActivate(_this.props.image.id);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDeactivate", function () {
      var onDeactivate = _this.props.onDeactivate;
      if (onDeactivate) onDeactivate(_this.props.image.id);
    });
    return _this;
  }

  (0, _createClass2["default"])(DraggableImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          isDragging = _this$props.isDragging,
          isActive = _this$props.isActive,
          gridSize = _this$props.gridSize,
          connectDragSource = _this$props.connectDragSource,
          connectDropTarget = _this$props.connectDropTarget,
          _onClick = _this$props.onClick;
      return _react["default"].createElement(_Card["default"], {
        isDragging: isDragging,
        isActive: isActive,
        gridSize: gridSize,
        onClick: function onClick(e) {
          return !isDragging && _onClick(image, e);
        },
        ref: function ref(instance) {
          connectDragSource(instance);
          connectDropTarget(instance);
        }
      }, _react["default"].createElement(_styles.ButtonContainer, {
        gridSize: gridSize
      }, _react["default"].createElement(_styles.IconButton, {
        name: image.isActive ? 'times-circle' : 'arrow-circle-up',
        onClick: image.isActive ? this.onDeactivate : this.onActivate
      })), _react["default"].createElement(_styles.Image, {
        image: image
      }));
    }
  }]);
  return DraggableImage;
}(_react.Component);

var _default = Target(Source(DraggableImage));

exports["default"] = _default;